/*
 * cart-tracking.js — GTM dataLayer-Push für AddToCart Events.
 * Single source of truth für alle Custom-Editoren.
 * Editor-Code ruft DLTrack.addToCart(cartResponse) direkt nach erfolgreichem /cart/add.js POST.
 * Zusätzlich: globaler Listener für das Prestige-Standard variant:add Event (theme.js Z. 2817)
 * — fängt Standard-ProductForm-Käufe ab, ohne theme.js patchen zu müssen.
 */
(function () {
  window.DLTrack = window.DLTrack || {};

  // Dedup-Cache: verhindert dass dasselbe Add (gleiche Variant + Value) innerhalb
  // von 2s zweimal getrackt wird. Cart-Drawer-Re-render kann variant:add erneut
  // dispatchen — der Listener feuert dann ein Duplicate.
  var lastTrack = { key: null, ts: 0 };
  var DEDUP_WINDOW_MS = 2000;

  window.DLTrack.addToCart = function (cartResponse) {
    try {
      var items = Array.isArray(cartResponse && cartResponse.items)
        ? cartResponse.items
        : (cartResponse && cartResponse.id ? [cartResponse] : []);
      if (!items.length) return;

      var value = items.reduce(function (sum, it) {
        var linePrice = it.final_line_price || it.line_price || ((it.price || 0) * (it.quantity || 1));
        return sum + (linePrice / 100);
      }, 0);

      // Dedup-Key: alle Variant-IDs zusammen + value
      var key = items.map(function (it) { return String(it.variant_id || it.id || ''); }).sort().join(',') + '|' + value;
      var now = Date.now();
      if (lastTrack.key === key && (now - lastTrack.ts) < DEDUP_WINDOW_MS) {
        return; // duplicate innerhalb des Fensters, skip
      }
      lastTrack = { key: key, ts: now };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'add_to_cart',
        _source: 'distantlines-editor',
        ecommerce: {
          currency: 'EUR',
          value: value,
          items: items.map(function (it) {
            return {
              item_id: String(it.variant_id || it.id || ''),
              item_name: it.product_title || it.title || '',
              item_variant: it.variant_title || '',
              item_brand: 'Distantlines',
              price: (it.price || 0) / 100,
              quantity: it.quantity || 1
            };
          })
        }
      });

      // Meta Conversions API (server-seitig): an unseren Hetzner-Endpunkt schicken,
      // der das Event mit IP + User-Agent + _fbp/_fbc an Metas CAPI weiterreicht
      // (volles Matching). Consent: nur bei Marketing-Erlaubnis (Shopify Customer Privacy).
      var contentIds = items.map(function (it) { return String(it.product_id || it.variant_id || it.id || ''); });
      var contents = items.map(function (it) {
        return { id: String(it.product_id || it.variant_id || it.id || ''), quantity: it.quantity || 1, item_price: (it.price || 0) / 100 };
      });
      var eventId = 'dl-atc-' + now + '-' + Math.floor(Math.random() * 1e6);

      var cp = window.Shopify && window.Shopify.customerPrivacy;
      var marketingDenied = !!(cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed() === false);
      if (!marketingDenied && typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
        var fbp = (document.cookie.match(/(?:^|;\s*)_fbp=([^;]+)/) || [])[1] || '';
        var fbc = (document.cookie.match(/(?:^|;\s*)_fbc=([^;]+)/) || [])[1] || '';
        var capiPayload = {
          event_id: eventId,
          value: value,
          currency: 'EUR',
          content_ids: contentIds,
          contents: contents,
          fbp: fbp,
          fbc: fbc,
          event_source_url: window.location.href
        };
        navigator.sendBeacon(
          'https://tiles.distantlines.de/api/v1/meta/atc/',
          new Blob([JSON.stringify(capiPayload)], { type: 'text/plain' })
        );
      }
    } catch (e) {
      console.warn('[DLTrack] addToCart failed:', e);
    }
  };

  document.addEventListener('variant:add', function (event) {
    if (event && event.detail && event.detail.items) {
      window.DLTrack.addToCart({ items: event.detail.items });
    }
  });
})();
